import { useState, useEffect } from 'react';

/**
 * サイドバー制御用カスタムフック
 * - レスポンシブ対応
 * - デスクトップ/モバイル状態管理
 * - サイドバーの開閉制御
 */
export const useSidebarControl = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const newIsDesktop = width >= 1024;
      
      setIsDesktop(newIsDesktop);
      
      // 画面サイズが変わった時のサイドバー状態の調整
      if (newIsDesktop && !isDesktop) {
        // モバイル → デスクトップ: サイドバーを閉じる（デスクトップでは常時表示）
        setSidebarOpen(false);
      } else if (!newIsDesktop && isDesktop) {
        // デスクトップ → モバイル: サイドバーを閉じる
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarOverlayClick = () => {
    if (!isDesktop) {
      setSidebarOpen(false);
    }
  };

  return {
    sidebarOpen,
    isDesktop,
    toggleSidebar,
    handleSidebarOverlayClick
  };
};